import { render, staticRenderFns } from "./aufgaben_offen.vue?vue&type=template&id=52e379b4&scoped=true"
import script from "./aufgaben_offen.vue?vue&type=script&lang=js"
export * from "./aufgaben_offen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e379b4",
  null
  
)

export default component.exports